import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import HeroSlider from "./HeroSlider";
import gsap from "gsap";
Swiper.use([Pagination]);

class VerticalConsumer {
    constructor() {
        this.init();
    }

    init() {
        this.heroImageAnimation();
        this.initSliders();
    }

    initSliders() {
        const swiperEl = document.querySelector('.cm-hero-slider');
        if(swiperEl) {
            new HeroSlider(swiperEl);
        }

        // var swiperCMFeatured = new Swiper('.cm-featured-slider', {
        //     slidesPerView: 1,
        //     spaceBetween: 24,
        //     loop: true,
        //     // adaptiveHeight: true,
        //     pagination: {
        //         el: '.swiper-pagination',
        //         clickable: true,
        //     },
        //     breakpoints: {
        //         640: {
        //             slidesPerView: 2,
        //         },
        //         1024: {
        //             slidesPerView: 3,
        //         },
        //         1440: {
        //             slidesPerView: 4,
        //         },
        //     }
        // });
    }


    heroImageAnimation(){
        const elStaggerAnimation = document.querySelectorAll('[data-appear-animation]');
        const consumerImageStack = document.querySelectorAll('[data-img-stack-fade]');

        gsap.timeline({delay: 0.5,
            onComplete: () => {
                this.imageLoopAnimation.map((item,index)=>{
                    item.play();
                })
            }

        }).fromTo(elStaggerAnimation, {
            opacity: 0,
            y: 50
        }, {
            duration: 0.5,
            opacity: 1,
            y: 0,
            stagger:{
                each: 0.05,
                from: "start",
                ease: "power2.out",
            }
        })


        this.imageLoopAnimation = gsap.utils.toArray(consumerImageStack).map((item,index)=>{
            let images = gsap.utils.toArray(item.querySelectorAll('img')),
                tl = gsap.timeline({repeat: -1,paused: true, delay: index * 0.5}),
                transitionTime = 0.5,
                showDuration = 4;
            gsap.set(images, {autoAlpha: 0});
            gsap.set(images[0], {autoAlpha: 1});
            if(images.length > 1) {
                return tl.to(images.slice(1), {delay: showDuration, autoAlpha: 1, duration: transitionTime, stagger: showDuration + transitionTime})
                    .to(images.slice(0, images.length-1), {autoAlpha: 0, duration:0.01, stagger: showDuration + transitionTime}, showDuration + transitionTime)
                    .set(images[0], {autoAlpha: 1})
                    .to(images[images.length-1], {autoAlpha: 0, duration: transitionTime}, "+=" + showDuration);
            } else {
                return gsap.timeline({paused:true,repeat: -1,delay: 1,}).to(images[0], {autoAlpha: 1, duration: transitionTime});
            }

        })
    }
}

export default VerticalConsumer;
